import PublicNotFound from "../scenes/notFoundPages/PublicNotFound";
import { Navigate, useLocation } from "react-router-dom";
import { isSessionValidForRoles } from "../utils/tokenGuard";
import { purgeLegacyJwtFromStorage } from "../utils/authSession";
import { useEffect } from "react";

export default function TenantRouteGuard({ children }) {
  const location = useLocation();

  useEffect(() => {
    purgeLegacyJwtFromStorage();
  }, []);

  if (!isSessionValidForRoles(["tenant"])) {
    return <PublicNotFound />;
  }

  const requiresCheckout = localStorage.getItem("tenantRequiresCheckout") === "true";
  const onCheckoutPage = location.pathname === "/tenant/checkout";

  if (requiresCheckout && !onCheckoutPage) {
    return <Navigate to="/tenant/checkout" replace />;
  }

  return children;
}
